export interface Dataset {
    set: string;
    value: number;
  }
  
  export interface DataItem {
    work_item_types: any;
    release: string;
    date: string;
    value?: number;
    datasets?: Dataset[];
  }
  
  export interface Metric {
    weight: string;
    show_breakdown: boolean;
    visibility:boolean;
    name: string;
    target?: string;
    units: string;
    data: DataItem[];
    current_release?:DataItem[];
    type: string;
  }
  
  export interface ChartDataItem {
    normalizedValues?: any;
    date: string;
    release: string;
    value?: number;
    labelsMapset: Record<string, number>;
  }
  
  export enum ChartType {
    LINE = "line",
    BAR = "bar",
    SCATTER = "scatter",
  }
  
  export enum StackingType {
    SIMPLE = "Simple",
    STACKED = "stacked",
    STACKED_100="stacked 100%"
  }

  
  export enum ChartColors {
    RED = "#FF6384",
    BLUE = "#36A2EB",
    YELLOW = "#FFCE56",
    TEAL = "#4BC0C0",
    ORANGE = "#FF9F40",
    PURPLE = "#9966FF",
    GRAY = "#C9CBCF",
    GREEN = "#2ECC71",
    PINK = "#E91E63",
    CYAN = "#00BCD4",
    INDIGO = "#3F51B5",
    LIME = "#CDDC39",
    BROWN = "#795548"
  }